/** ABテストのバリアント。/driver → A、/drivers → B */
export type Variant = "A" | "B";

/** 単一選択・テキスト系の回答キー */
export type SingleKey =
  | "intent" | "license" | "at" | "status" | "zip" | "area" | "gender" | "tel";

/** 複数選択の回答キー */
export type MultiKey = "quals" | "prefer";

export interface Answers {
  intent: string;
  license: string;
  at: string;
  status: string;
  zip: string;
  /** 郵便番号から引いた住所（表示と配信の補助。取得失敗時は空） */
  zipAddr: string;
  area: string;
  gender: string;
  tel: string;
  quals: string[];
  prefer: string[];
  last: string;
  first: string;
  by: string;
  bm: string;
  bd: string;
  /** by/bm/bd から組み立てた YYYY-MM-DD */
  birth: string;
  agree: boolean;
}

export const emptyAnswers = (): Answers => ({
  intent: "", license: "", at: "", status: "", zip: "", zipAddr: "",
  area: "", gender: "", tel: "", quals: [], prefer: [],
  last: "", first: "", by: "", bm: "", bd: "", birth: "", agree: false,
});

export interface ImgOption {
  v: string;
  img: string;
}

interface StepBase {
  id: string;
  title: string;
  help?: string;
  required?: boolean;
  /** false を返すステップはスキップされ、進捗の総数からも除外されます */
  when?: (a: Answers) => boolean;
}

export type Step =
  | (StepBase & { type: "radio"; key: SingleKey; options: string[] })
  | (StepBase & { type: "tiles"; key: SingleKey; options: ImgOption[] })
  | (StepBase & { type: "check"; key: MultiKey; options: string[]; none: string })
  | (StepBase & { type: "checkImg"; key: MultiKey; options: ImgOption[]; none: string })
  | (StepBase & {
      type: "text" | "tel";
      key: SingleKey;
      placeholder?: string;
      maxlength?: number;
      mode?: "text" | "numeric" | "tel";
      /** true にすると郵便番号→住所の自動表示が有効になります */
      zip?: boolean;
      validate?: (v: string) => string;
    })
  | (StepBase & { type: "birth"; validate?: (v: string) => string })
  | (StepBase & { type: "name" })
  | (StepBase & { type: "consent" });

/** 単一選択・テキスト系のキーを持つステップか */
export function hasSingleKey(
  s: Step
): s is Extract<Step, { key: SingleKey }> {
  return s.type === "radio" || s.type === "tiles" || s.type === "text" || s.type === "tel";
}
